<template>
  <div class="pdf-content-body" ref="pdfContentBody">
    <div class="row" v-if="pdf !== null">
      <pdf-doc :pdf="pdf" :selectedPdf="selectedPdf" :id="pdfId"></pdf-doc>
      <pdf-extraction :key="selectedPdf" :pdfId="pdfId"></pdf-extraction>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { getPdfIndexById } from '@/data/getters';
import PdfDoc from '@/components/includes/pdf/PdfDoc';
import PdfExtraction from '@/components/includes/pdf/PdfExtraction';
import {EventBus} from "../../../event-bus";
import { PDF_FILE_TYPE } from '@/config';

export default {
  name: 'pdf-content-body',
  data()  {
    return {
      pdf: null
    }
  },
  components: {
    'pdf-doc': PdfDoc,
    'pdf-extraction': PdfExtraction
  },
  props: {
    selectedPdf: {
      type: Number,
      required: true
    },
  },
  computed: {
    pdfId() {
      return this.allData.pdfs[this.selectedPdf].id;
    },
    ...mapGetters('login',{
      allData: 'getAllData'
    }),
  },
  beforeDestroy () {
    // clean up
    this.pdf = null;
    delete this.pdf;
  },
  methods: {
    ...mapActions('login/pdf', [
      'requestPdfById',
    ]),
    loadPdf() {
      let loader = this.$loading.show({},{
        after: this.$createElement('div',{},['Transfering data to pdf viewer...'])
      });
      this.requestPdfById(this.pdfId)
        .then((pdf) => {
          this.pdf = pdf;
        })
        .catch((err) => {
          console.error(err);
          this.$swal({
            type: 'error',
            title: `Unable to retrieve`,
            text: `Unable to retrieve PDF. Please try again or choose another file.`
          })
        }).finally( () => {
          loader.hide();
          loader = null;
        });
    },
  },
  created () {
    // console.dir(this);
    this.loadPdf();
  }
}
</script>

<style scoped lang="scss">

</style>
